import com from '../../../../../comMapping.js'
export function getdata() {
	let obj = {
		searchlist: [{
				prop: "tes1",
				label: '数电票号码',
				type: "input",
			}, {
				prop: "tes2",
				label: '单据号',
				type: "input"
			}, {
				prop: "tes3",
				label: '单据状态',
				type: "select"
			}, {
				prop: "tes4",
				label: '发票类型',
				type: "select"
			},
			{
				prop: "tes5",
				label: '开票时间',
				type: "date"
			},
			{
				prop: "tes6",
				label: '购方名称',
				type: "input"
			},
			{
				prop: "tes7",
				label: '任务批次号',
				type: "input"
			},
			{
				prop:"tes8",
				label:"价税合计",
				type:"inputplus"
			}
		],
		searchdata: {
			tes1: "",
			tes2: "",
			tes3: "",
			tes4: "",
			tes5: "",
			tes6: "",
			tes7: "",
			tes8: "",
		},
		headData: [{
				title: '数电票号码',
				prop: 'tes1',
				width: '160',
				issort: true,
			},
			{
				title: '单据号',
				prop: 'tes2',
				width: '160',
				issort: true,
			},
			{
				title: '单据状态',
				prop: 'tes3',
				width: '120',
				showFilter: true,
				custom:true,
				checkList: com.lqdjzt.map(item=>item.code),
				dataList: com.lqdjzt
			},
			{
				title: '发票类型',
				prop: 'tes4',
				width: '120',
				showFilter: true,
				custom:true,
				checkList: com.lqfplx.map(item=>item.code),
				dataList:com.lqfplx
			},
			{
				title: '开票时间',
				prop: 'tes5',
				width: '160',
				issort: true,
			},
			{
				title: '价税合计',
				prop: 'tes6',
				width: '150',
				issort: true,
				align: "right",
				AmountFormat:true
			},
			{
				title: '购方名称',
				prop: 'tes7',
				width: '160',
				issort: true,
				align:"left"
			},
			{
				title: '任务批次号',
				prop: 'tes8',
				width: '160',
				issort: true,
				align:"left"
			},
			{
				title: '最近执行时间',
				prop: 'tes9',
				width: '160',
				issort: true,
			},
			{
				title: '任务完成时间',
				prop: 'tes10',
				width: '160',
				issort: true,
			},
			{
				title: '单据来源',
				prop: 'tes11',
				width: '120',
				showFilter: true,
				checkList: [],
				dataList:[]
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}